import {uniq} from "lodash";
import {UserPermissionEnum} from "../../utils/types/user";
import {
  ADMISSIONS_COMPLETION_ON_TIME_CHART_ID,
  ADMISSIONS_COMPLETION_OVERALL_CHART_ID,
  ADMISSIONS_TIME_BY_STAGE_CHART_ID,
  ADMISSIONS_TOTAL_CHART_ID,
  ADMISSIONS_TOTAL_RESIDENTS_CHART_ID,
  ARBITRATION_AGREEMENT_RATE_CHART_ID,
  FACILITY_COMPLETION_RATE_CHART_ID,
  FACILITY_MEDICARE_CHART_ID,
  FLAGS_AGE_CHART_ID,
  FLAGS_BY_SLIDE_CHART_ID,
  MANAGED_MEDICAID_BY_FACILITY_CHART_ID,
  MANAGED_MEDICAID_CHART_ID,
  PAYER_SOURCE_65_75_BY_COUNTRY_CHART_ID,
  PAYER_SOURCE_65_75_CHART_ID,
  PAYER_SOURCE_75_85_BY_COUNTRY_CHART_ID,
  PAYER_SOURCE_75_85_CHART_ID,
  PAYER_SOURCE_85_BY_COUNTRY_CHART_ID,
  PAYER_SOURCE_85_CHART_ID,
  RE_ADMISSION_RATE_BY_FACILITY_CHART_ID,
  RE_ADMISSION_RATE_CHART_ID,
  REPRESENTATIVE_RATE_BY_FACILITY_CHART_ID,
  REPRESENTATIVE_RATE_CHART_ID,
  STAFF_COMPLETION_RATE_CHART_ID,
  TIME_TO_CLOSE_BY_FACILITY_CHART_ID,
  WITHOUT_MEDICARE_SUPPLEMENT_BY_FACILITY_CHART_ID,
  WITHOUT_MEDICARE_SUPPLEMENT_CHART_ID,
} from "./analytics";
import {
  AD_HELP_REPORT_ID,
  AD_PROVIDED_REPORT_ID,
  ARBITRATION_AGREEMENT_REPORT_ID,
  CHECKLIST_ITEM_REPORT_ID,
  FACILITY_CHANGES_REPORT_ID,
  FUNERAL_REPORT_ID,
  INCOME_REPORT_ID,
  INFLUENZA_REPORT_ID,
  LAUNDRY_REPORT_ID,
  LIST_OF_RESIDENTS_REPORT_ID,
  MEDICAID_REQUEST_REPORT_ID,
  MEDICARE_WAIVER_REPORT_ID,
  PHOTOS_REPORT_ID,
  PNEUMOCOCCAL_REPORT_ID,
  SLIDE_INTERACTIONS_REPORT_ID,
  SNFABN_COST_ADMISSION_REPORT_ID,
  STAFF_REPORT_ID,
  SURROGATE_HELP_REPORT_ID,
  SURROGATE_REPORT_ID,
  TOTAL_ADMISSIONS_REPORT_ID,
  TRUST_FUND_REPORT_ID,
} from "./reports";
import {DASHBOARD_REPORT_ID} from "./reports/ReportQuicksightDashboard";

// TODO: Charts have defined permissions already, use that so we have single source of truth
export const BLOCK_PERMISSIONS: {
  [key: string]: UserPermissionEnum[];
} = {
  [ADMISSIONS_TOTAL_CHART_ID]: [
    UserPermissionEnum.APPROVED_ARCHIVED_ADMISSIONS,
    UserPermissionEnum.PERCENTAGE_OF_ADMISSIONS_COMPLETED_BY_REPRESENTATIVE,
    UserPermissionEnum.AVG_TIME_SPENT_TO_CLOSE_ADMISSION,
  ],
  [TIME_TO_CLOSE_BY_FACILITY_CHART_ID]: [
    UserPermissionEnum.COMPLETION_RATE_ONCE_ADMISSION_IS_SIGNED,
  ],
  [REPRESENTATIVE_RATE_CHART_ID]: [
    UserPermissionEnum.PERCENTAGE_OF_ADMISSIONS_COMPLETED_BY_REPRESENTATIVE,
  ],
  [REPRESENTATIVE_RATE_BY_FACILITY_CHART_ID]: [
    UserPermissionEnum.PERCENTAGE_OF_ADMISSIONS_COMPLETED_BY_REPRESENTATIVE,
  ],
  [MANAGED_MEDICAID_CHART_ID]: [
    UserPermissionEnum.RESIDENTS_WITH_MANAGED_MEDICAID,
  ],
  [MANAGED_MEDICAID_BY_FACILITY_CHART_ID]: [
    UserPermissionEnum.RESIDENTS_WITH_MANAGED_MEDICAID,
  ],
  [WITHOUT_MEDICARE_SUPPLEMENT_CHART_ID]: [
    UserPermissionEnum.PATIENTS_WITHOUT_MEDICAL_SUPPLEMENT,
  ],
  [WITHOUT_MEDICARE_SUPPLEMENT_BY_FACILITY_CHART_ID]: [
    UserPermissionEnum.PATIENTS_WITHOUT_MEDICAL_SUPPLEMENT,
  ],
  [RE_ADMISSION_RATE_CHART_ID]: [UserPermissionEnum.READMISSION_RATE],
  [RE_ADMISSION_RATE_BY_FACILITY_CHART_ID]: [
    UserPermissionEnum.READMISSION_RATE,
  ],
  [ADMISSIONS_TOTAL_RESIDENTS_CHART_ID]: [
    UserPermissionEnum.ANALYTICS_ADMISSION_IN_TOTAL,
    UserPermissionEnum.READMISSION_RATE,
    UserPermissionEnum.RESIDENTS_WITH_MANAGED_MEDICAID,
    UserPermissionEnum.PATIENTS_WITHOUT_MEDICAL_SUPPLEMENT,
  ],
  [FACILITY_COMPLETION_RATE_CHART_ID]: [
    UserPermissionEnum.ADMISSION_COMPLETION_RATE,
  ],
  [STAFF_COMPLETION_RATE_CHART_ID]: [
    UserPermissionEnum.ADMISSION_COMPLETION_RATE,
  ],
  [ADMISSIONS_COMPLETION_ON_TIME_CHART_ID]: [
    UserPermissionEnum.COMPLETION_TIME,
  ],
  [ADMISSIONS_COMPLETION_OVERALL_CHART_ID]: [
    UserPermissionEnum.COMPLETION_TIME,
  ],
  [ARBITRATION_AGREEMENT_RATE_CHART_ID]: [
    UserPermissionEnum.ARBITRATION_AGREEMENT_COMPLETED,
  ],
  [FACILITY_MEDICARE_CHART_ID]: [
    UserPermissionEnum.PATIENTS_WITH_MEDICAL_SUPPLEMENT,
  ],
  [ADMISSIONS_TIME_BY_STAGE_CHART_ID]: [
    UserPermissionEnum.AVG_TIME_SPENT_OF_EACH_STAGE_OF_ADMISSION,
  ],
  [FLAGS_AGE_CHART_ID]: [UserPermissionEnum.AGE_OF_HELP_FLAGS],
  [FLAGS_BY_SLIDE_CHART_ID]: [
    UserPermissionEnum.MOST_FREQUENTLY_FLAGGED_SLIDES,
  ],
  [PAYER_SOURCE_65_75_CHART_ID]: [UserPermissionEnum.PAYER_SOURCE_AGE_65_75],
  [PAYER_SOURCE_65_75_BY_COUNTRY_CHART_ID]: [
    UserPermissionEnum.PAYER_SOURCE_AGE_65_75,
  ],
  [PAYER_SOURCE_75_85_CHART_ID]: [UserPermissionEnum.PAYER_SOURCE_AGE_75_85],
  [PAYER_SOURCE_75_85_BY_COUNTRY_CHART_ID]: [
    UserPermissionEnum.PAYER_SOURCE_AGE_75_85,
  ],
  [PAYER_SOURCE_85_CHART_ID]: [UserPermissionEnum.PAYER_SOURCE_AGE_85],
  [PAYER_SOURCE_85_BY_COUNTRY_CHART_ID]: [
    UserPermissionEnum.PAYER_SOURCE_AGE_85,
  ],
  [TOTAL_ADMISSIONS_REPORT_ID]: [UserPermissionEnum.ADMISSION_IN_TOTAL],
  [LIST_OF_RESIDENTS_REPORT_ID]: [UserPermissionEnum.ADMISSION_IN_TOTAL],
  [ARBITRATION_AGREEMENT_REPORT_ID]: [UserPermissionEnum.ARBITRATION_AGREEMENT],
  [INCOME_REPORT_ID]: [UserPermissionEnum.INCOMES_AND_PERSONAL_RESOURCE],
  [TRUST_FUND_REPORT_ID]: [UserPermissionEnum.TRUST_FUND_POLICY],
  [PNEUMOCOCCAL_REPORT_ID]: [UserPermissionEnum.PNEUMOCOCCAL_VACCINES],
  [INFLUENZA_REPORT_ID]: [UserPermissionEnum.INFLUENZA_VACCINES],
  [SURROGATE_REPORT_ID]: [UserPermissionEnum.SURROGATE_DECISION_MAKING],
  [SURROGATE_HELP_REPORT_ID]: [
    UserPermissionEnum.SURROGATE_DECISION_RESIDENTS_REQUESTING_FOR_MORE_INFORMATION,
  ],
  [AD_HELP_REPORT_ID]: [
    UserPermissionEnum.RESIDENTS_REQUESTING_FOR_HELP_WITH_CREATING_ADVACED_DIRECTIVE,
  ],
  [AD_PROVIDED_REPORT_ID]: [
    UserPermissionEnum.EXISTING_ADVANCED_DIRECTIVE_PROVIDED,
  ],
  [MEDICARE_WAIVER_REPORT_ID]: [UserPermissionEnum.MEDICARE_WAIVER],
  [MEDICAID_REQUEST_REPORT_ID]: [
    UserPermissionEnum.RESIDENTS_REQUESTING_APPLICATION_FROM_MEDICAID,
  ],
  [SNFABN_COST_ADMISSION_REPORT_ID]: [
    UserPermissionEnum.ESTIMATED_COST_TRACKED_BY_ROLE_AND_DATE,
  ],
  [STAFF_REPORT_ID]: [UserPermissionEnum.STAFF_ADMISSIONS],
  [FACILITY_CHANGES_REPORT_ID]: [UserPermissionEnum.FACILITY_CHANGES],
  [FUNERAL_REPORT_ID]: [UserPermissionEnum.FUNERAL],
  [LAUNDRY_REPORT_ID]: [UserPermissionEnum.LAUNDRY_CONSENT],
  [PHOTOS_REPORT_ID]: [UserPermissionEnum.PHOTOS],
  [SLIDE_INTERACTIONS_REPORT_ID]: [UserPermissionEnum.SLIDE_INTERACTIONS],
  [CHECKLIST_ITEM_REPORT_ID]: [UserPermissionEnum.CHECKLIST_ITEMS],
  [DASHBOARD_REPORT_ID]: [UserPermissionEnum.QUICKSIGHT_DASHBOARDS],
};

export const PERMISSION_BLOCKS = Object.entries(BLOCK_PERMISSIONS)
  .map(([block, permissions]) => [permissions, block])
  .reduce<{[k in UserPermissionEnum]?: string[]}>(
    (data, [permissions, block]) => ({
      ...data,
      ...(permissions as UserPermissionEnum[]).reduce(
        (acc, permission) => ({
          ...acc,
          [permission]: data[permission]
            ? [...data[permission], block]
            : [block],
        }),
        {},
      ),
    }),
    {},
  );

export const getSectionItemsPermissions = (
  sectionItems: ReadonlyArray<string>,
) =>
  uniq(
    sectionItems.reduce(
      (permissions, section) => [
        ...permissions,
        ...(BLOCK_PERMISSIONS[section] ?? []),
      ],
      [],
    ),
  );

export const getSectionsForPermissions = (
  permissions: ReadonlyArray<UserPermissionEnum>,
) =>
  permissions.reduce(
    (sections, permission) => [
      ...sections,
      ...(PERMISSION_BLOCKS[permission] || []),
    ],
    [],
  );
